// src/components/services/DescriptiveAccordion.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './DescriptiveAccordion.css';

function DescriptiveAccordionItem({ service, isOpen, onToggle }) {
  return (
    <div className={`desc-accordion-item ${isOpen ? 'open' : ''}`}>
      <div 
        className="desc-accordion-header" 
        onClick={onToggle}
        role="button"
        tabIndex={0}
        aria-expanded={isOpen}
        aria-controls={`desc-content-${service.id}`}
        onKeyPress={(e) => e.key === 'Enter' && onToggle()}
      >
        <div className="header-content">
          {service.icon && <span className="accordion-icon" role="img" aria-label="">{service.icon}</span>}
          <h3>{service.categoryTitle}</h3>
        </div>
        <span className="desc-accordion-toggle-icon">+</span>
      </div>
      {isOpen && (
        <div className="desc-accordion-content" id={`desc-content-${service.id}`}>
          {service.descriptionPoints && service.descriptionPoints.length > 0 && (
            <ul>
              {service.descriptionPoints.map((point, index) => (
                <li key={index}>{point}</li>
              ))}
            </ul>
          )}
          {service.contactLinkText && (
            <div className="contact-link-wrapper">
              <Link to={service.contactLink || "/contact"} className="btn btn-secondary btn-small">
                {service.contactLinkText}
              </Link>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

function DescriptiveAccordion({ services }) {
  const [openItemId, setOpenItemId] = useState(null); // ID de l'item ouvert, ou null

  const handleToggle = (itemId) => {
    setOpenItemId(openItemId === itemId ? null : itemId);
  };

  if (!services || services.length === 0) {
    return <p>Nos services seront détaillés ici prochainement.</p>;
  }

  return (
    <section className="descriptive-accordion-section">
      {/* Le titre H1 "Nos Services" est déjà sur la page ServicesPage.js */}
      {/* On pourrait ajouter un sous-titre ici si besoin */}
      {/* <h2 className="section-title">Découvrez nos prestations en détail</h2> */}
      <div className="accordion-container">
        {services.map(service => (
          <DescriptiveAccordionItem
            key={service.id}
            service={service}
            isOpen={openItemId === service.id}
            onToggle={() => handleToggle(service.id)}
          />
        ))}
      </div>
    </section>
  );
}

export default DescriptiveAccordion;